import classNames from "classnames";
import React from "react";
import { NavLink } from "react-router-dom";

import useLayout from "@hooks/reducerHooks/useLayout";

interface IProps {
  goToUrl: string;
  name: string;
  clickHandler?: () => void;
}

function NavMenuItem({ goToUrl, name, clickHandler }: IProps) {
  const { closeHeader } = useLayout();

  return (
    <li
      onClick={() => {
        closeHeader();
        clickHandler?.();
      }}
      role="presentation"
    >
      <NavLink to={goToUrl}>
        <span
          className={classNames(
            "inline-block",
            (name.toLowerCase().includes("sale") || name.includes("Season Off")) && "bg-highlight text-white",
          )}
        >
          {name}
        </span>
      </NavLink>
    </li>
  );
}

export default NavMenuItem;
